export default __webpack_public_path__ + "static/media/hero-premium.cfb3c6c7.png";